<!--
 * @Author: ken yang
 * @Date: 2022-11-28 11:15:05
 * @LastEditTime: 2023-04-24 10:28:03
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/layout/components/Sidebar/SidebarItem.vue
-->
<template>
  <template v-if="hasOnlyChild(item)">
    <el-menu-item class="position-r" :index="item.path">
      <div v-if="item.icon" class="m-r-16 ">
        <IconSvg :name="item.icon" />
      </div>
      <span :class="route.path == item.path ? 'bold' : ''">{{ $t(item.meta.title) }}</span>
      <div v-if="item.path == route.path" class="position-a top-0 bottom-0 right-0 w-2 bg-primary" />
    </el-menu-item>
  </template>

  <el-sub-menu
    v-else
    ref="subMenu"
    class="w-100b"
    popper-append-to-body
    :index="item.path"
  >
    <template #title>
      <div v-if="item.icon" class="m-r-16 ">
        <IconSvg :name="item.icon" />
      </div>
      <span v-if="!collapse">{{ $t(item.meta.title) }}</span>
    </template>
    <sidebar-item
      v-for="child in item.children"
      :key="child.name"
      class="w-100b"
      :item="child"
    />
  </el-sub-menu>

</template>
<script setup>
const route = useRoute()
const userStore = useUserStore()

const props = defineProps({
  item: {},
  collapse: {
    default: false
  }
})

const curFirstRoute = $computed(() => { // 当前一级菜单路由对象
  const route = router.currentRoute.value
  const { path } = route
  const firPathName = path.split('/')[1]
  const targetFirstRoute = userStore.menuRouters.find((obj) => {
    return obj?.path?.includes(firPathName)
  })
  return targetFirstRoute
})

const iconActive = (name) => {
  return curFirstRoute?.name === name
}

const hasOnlyChild = (router) => {
  // console.log('5555555', router?.children && router?.children.length === 1)
  // return true
  // return router?.children && router?.children.length === 1
  return isEmpty(router.children)
}
onBeforeMount(() => {
})
</script>
<style lang="scss">
@use "sass:math";
@use "sass:map";
@import "@/sass/var/index.scss";

.sidebar-container{
  --el-menu-icon-width:14px;
  .el-sub-menu__icon-arrow{
    color: $color-info !important;
  }
}
</style>
